// Show device tab on deeplink modal
;
(function () {

    if (device.android()) {
        $('#tabs-deeplink-deo-android').addClass('is-active');
        $('[data-tabs-show="tabs-deeplink-deo-android"]').addClass('is-active');
        $('#tabs-deeplink-slr-android').addClass('is-active');
        $('[data-tabs-show="tabs-deeplink-slr-android"]').addClass('is-active');
    } else if (isOculusGo() || isOculusQuest()) {
        $('#tabs-deeplink-deo-oculus').addClass('is-active');
        $('[data-tabs-show="tabs-deeplink-deo-oculus"]').addClass('is-active');
        $('#tabs-deeplink-slr-oculus').addClass('is-active');
        $('[data-tabs-show="tabs-deeplink-slr-oculus"]').addClass('is-active');
    } else {
        $('#tabs-deeplink-deo-pc').addClass('is-active');
        $('[data-tabs-show="tabs-deeplink-deo-pc"]').addClass('is-active');
        $('#tabs-deeplink-slr-pc').addClass('is-active');
        $('[data-tabs-show="tabs-deeplink-slr-pc"]').addClass('is-active');
    }

    function isOculusGo() {
        return /Pacific.+OculusBrowser.+Mobile.?VR/i.test(window.navigator.userAgent) // oculus browser
            || /SAMSUNG.?Pacific.+Mobile.?VR/i.test(window.navigator.userAgent); // samsung internet
    }

    function isOculusQuest() {
        return /Quest.+OculusBrowser.+Mobile.?VR/i.test(window.navigator.userAgent) // oculus browser
        // TODO add support for Samsung Internet when (and if) it is released for Quest
    }
})();